import { TESTIMONIALS } from "../../data/content";
import { Reveal } from "./Reveal";

export const Testimonials = () => (
  <section className="section section--alt" aria-labelledby="impact-heading">
    <div className="container">
      <div className="section-header" style={{ textAlign: "center" }}>
        <div className="section-label">Selected Impact</div>
        <h2 className="section-heading" id="impact-heading">Evidence That <em>Moved Decisions</em></h2>
        <p className="section-sub" style={{ marginInline: "auto" }}>
          Documented outcomes from recent engagements — the kind of decision-grade evidence
          that shapes funding, adaptation, and policy.
        </p>
      </div>
      <div className="testimonials-grid">
        {TESTIMONIALS.map((t, i) => (
          <Reveal className="testimonial-card" key={t.program} delay={i * 80} data-testid={`testimonial-${i}`}>
            <div className="testimonial-mark" aria-hidden="true">“</div>
            <p className="testimonial-quote">{t.quote}</p>
            <div className="testimonial-author">
              <div className="testimonial-avatar" aria-hidden="true">{t.initials}</div>
              <div>
                <div className="testimonial-name">{t.program}</div>
                <div className="testimonial-role">{t.attribution}</div>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
